import { customEvents } from '../../utils/dom';
import {
  TValidationField,
  TFieldValidationResult,
  TSuccessfulValidation,
  TValidationResult,
} from './types';
import { validateByRules } from './validationMethods';

/**
 * Realiza la validación del campo tomando en cuenta las
 * distintas posibilidades de validación.
 */
export async function validateField(
  field: TValidationField<unknown>,
  formName: string,
): Promise<TFieldValidationResult> {
  let validationResult: TFieldValidationResult | null = null;
  const fieldValue = field.validationValueParser
    ? field.validationValueParser(field.value)
    : field.value;
  if (field.validationFunction) {
    validationResult = await field.validationFunction(fieldValue, formName);
  }
  if (
    (!field.validationFunction || validationResult === true) &&
    field.validationRules
  ) {
    validationResult = validateByRules({
      rules: field.validationRules,
      value: fieldValue,
    });
  } else if (validationResult === null) validationResult = true;
  return validationResult;
}

/**
 * Determina si la validación de un campo resultó exitosa.
 */
export function hasSucceedFieldValidation(
  result: TFieldValidationResult,
): result is true {
  return result === true;
}

/**
 * Determina si la validación de un formulario resultó
 * exitosa. Está pensada para utilizar en el callback
 * onValidate de Form o en la acción validationsActions.validateForm
 */
export function hasSucceedFormValidation<
  ValueType extends Record<string, unknown>,
  SubmitValueType extends Record<keyof ValueType, unknown> = ValueType,
>(
  result: TValidationResult<ValueType, SubmitValueType>,
): result is TSuccessfulValidation<ValueType, SubmitValueType> {
  return !('errors' in result);
}

/**
 * Intenta hacer foco en el campo y devuelve un booleano
 * indicando si se logró o no.
 */
export async function focusOnField(formName: string, field: TValidationField) {
  const formElement = document.getElementById(
    `ValidationForm-${formName}`,
  ) as HTMLFormElement;
  const fieldElement: HTMLElement | null = formElement?.querySelector(
    `[name="${CSS.escape(field.name)}"], #${CSS.escape(field.name)}`,
  );

  if (fieldElement) {
    return new Promise((resolve) => {
      const event = new CustomEvent(customEvents.focus, { bubbles: true });
      fieldElement.focus();
      fieldElement.dispatchEvent(event);
      fieldElement.scrollIntoView({
        block: 'center',
        behavior: 'auto',
      });
      resolve(true);
    });
  }
  return false;
}
